import { OneRemoveMembersDocument } from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { handleResult } from 'modules/core/lib/handleMutation'
import {
  OneCreateAction,
  OneCreationActionResolver,
} from 'modules/core/lib/oneCreateActions/types'
import { POSTS_POLICIES } from 'modules/posts/lib/postsPolicies'

const useRemoveMembersActionResolver: OneCreationActionResolver = () => {
  const { navigation } = useNavigation()

  const [removeMembers, { loading }] = useMutation(OneRemoveMembersDocument, {
    extractorFn: (data) => data.postsMutations.removeMembersPostsGroup,
    errorPolicy: 'all',
  })

  const removeMembersHandler = async (args: { groupId: string; employeeIds: string[] }) => {
    const result = await removeMembers({
      variables: {
        id: args.groupId,
        employeeIds: args.employeeIds,
      },
    })

    const handled = handleResult(result, (_errors) => {})

    if (handled.success && handled.data.group?.id) {
      const url =
        handled.data.group.frontendUrl ??
        navigation.communities.id.fullPath({ id: handled.data.group.id })

      return {
        to: url,
        data: args,
      }
    }

    return handled
  }

  return {
    resolver: removeMembersHandler,
    loading,
  }
}

export const RemoveMembersAction: OneCreateAction = {
  actionResolver: useRemoveMembersActionResolver,
  policies: [POSTS_POLICIES.postsManage],
}
